<div class="component-root">
  <div :class="['editor-wrapper' , errorStatus ? 'error-border' : '']">
    <EditorBar v-if="editor" :editor="editor"/>
    <EditorBody
      :editor="editor"
      :diffEditor="diffEditor"
      :isDiffView="isDiffView"
      :isAiResponseLoading="isAiResponseLoading"
      :aiSuggestedText="aiSuggestedText"
      :characterCount="characterCount"
      :feedbackGiven="feedbackGiven"
      :updateFeedback="updateFeedback"
      :assetType="editorConfig.assetType"
      :feedbackId="currentFeedbackId"
    />
  </div>
  <ErrorContainer 
   :validationData="validationData"
   :aiSuggestedErrors="aiSuggestedErrors"
   :forcedErrors="forcedErrors"
   :isAiEnabled="isAiEnabled"
   :foundryId="foundryId"
   :moduleName="editorConfig.assetType"
   @error-status="handleErrorStatus"
   @on-validation-done="onValidationDone"
   @banned-word-update="handleBannedWordResult($event)"
  />
  <div data-qa-id="char-count-wrapperAI" v-if="isAiEnabled" class="char-count-wrapper">
    <MdTypography data-qa-id="char-count-wrapperAI-editor" variant="body2--regular" color="spirits--700" tag="span" v-if="isDiffView">
      {{ characterCount.editor }}/{{characterCountLimit}}
    </MdTypography>
    <MdTypography data-qa-id="char-count-wrapperAI-aiSuggestion" variant="body2--regular" color="spirits--700" tag="span" v-if="isDiffView">
      {{ characterCount.aiSuggestion }}/{{characterCountLimit}}
    </MdTypography>
    <MdTypography data-qa-id="char-count-wrapperAI-editor-count" variant="body2--regular" color="spirits--700" tag="span" v-else>
      {{ characterCount.editor }}/{{characterCountLimit}}
    </MdTypography>
  </div>
  <div v-else data-qa-id="char-count-wrapper-editor" class="char-count-wrapper">
    <MdTypography data-qa-id="char-count-wrapper-editor-count" variant="body2--regular" color="spirits--700" tag="span">
      {{ characterCount.editor }}/{{characterCountLimit}}
    </MdTypography>
  </div>
  <EditorFooter
    v-if="editorConfig.aiEnabled"
    :config="editorConfig"
    :editorValue="initialValue"
    :isAiEnabled="isAiEnabled"
    :isDiffView="isDiffView"
    :isAiResponseLoading="isAiResponseLoading"
    :lastReplacedAction="lastReplacedAction"
    :characterCount="characterCount"
    :errorStatus="disableAIActionBasedOnValidation"
    :aiResponseError="aiResponseError"
    @toggle-ai="handleAiToggle"
    @ai-action="handleAiAction"
    @discard="discardSuggestion"
    @replace="replaceSuggestion"
  />
  <AiConsentModal
    v-if="showAiConsentModal"
    :show="showAiConsentModal"
    :updateConsent="editorConfig.updateConsent"
    @cancel="handleConsentCancel"
    @enable-ai="enableAiFeatures"
  />
</div>
